import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AesEncryptDecryptService {
  secretKey = 'AÇ8ak9a8a7af9a57@#5afGg1%$4¨!!5QerqeQ%%$qtqtyeyrQYqery';

  constructor() { }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  }

  decrypt(textToDecrypt: string) {
    if (!textToDecrypt) {
      return null;
    } else {
      return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey).toString(
        CryptoJS.enc.Utf8
      );
    }
  }
}
